import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import FormTitle from 'components/PageLayout/FormTitle';
import { Button } from 'components/curo-components/common/Button';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { CuroApplicationVariables } from 'enums/curo/Variables';
import { resetApplication } from 'handlers/curo-handlers/applicationProcessSlice';
import { getApplicationSelector } from 'handlers/curo-handlers/selectors';
import { useAppDispatch } from 'hooks/reduxHooks';

import styles from './EndPages.module.scss';
import { CALL_US_BUTTON_TEXT, APPLY_NOW } from './constants';

const PAGE_TITLE = 'Thank you for coming back';
const getPageDescription = (phone: string) => (
  <p className={styles.descriptionWrapper}>
   Welcome back! Unfortunately, your offer has expired, but we are here to help. 
   Simply complete and resubmit your application. There is no impact on your credit for this application.
    <br />
    <br />
    Can’t wait to talk? You can call us right now!
    <br />
    <strong>{phone}</strong>
  </p>
);

const RefiApplicationExpiredPage = () => {
  const application = useSelector(getApplicationSelector);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const branchPhone = application?.variables[CuroApplicationVariables.SnowflakeBorrowerBranchPhone] as string;

  const callByPhone = () => {
    window.open(`tel:${branchPhone}`, '_self');
  };

  const applyNow = () => {
    dispatch(resetApplication());
    navigate(CuroAppRoute.ApplyProcess);
  };

  return (
    <>
      <FormTitle title={PAGE_TITLE} subTitle={getPageDescription(branchPhone)} />
      <div className={styles.buttonsWrapper}>
        <Button onClick={applyNow} kind="primary" size="form">
        {APPLY_NOW}
        </Button>
        <Button onClick={callByPhone} kind="secondary" size="form">
          {CALL_US_BUTTON_TEXT}
        </Button>
      </div>
    </>
  );
};

export default RefiApplicationExpiredPage;
